import { render, staticRenderFns } from "./tuis-edit.vue?vue&type=template&id=ed29bd4a&"
import script from "./tuis-edit.vue?vue&type=script&lang=js&"
export * from "./tuis-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports